module.exports = __webpack_public_path__ + "img/checked-icon-disabled.333f556b.svg";